<template>
  <div>
    <section class="wrapper__billing-p12">
      <h4 class="h4 font-bold mt-3">Configuración de Firma Electrónica</h4>

      <el-form :model="form" ref="form" :rules="rules">
        <!-- Upload card -->
        <div class="sig-upload-card">
          <div class="sig-upload-icon">
            <i class="el-icon-document sig-upload-icon-inner"></i>
          </div>
          <div class="sig-upload-info">
            <p class="sig-upload-label">Firma electrónica</p>
            <p class="sig-upload-hint">
              Sube tu archivo .p12 de firma electrónica
            </p>
            <div
              v-if="getBusinessSriFile && !form.file"
              class="sig-upload-status"
            >
              <i class="el-icon-circle-check"></i>
              Archivo cargado en la plataforma
            </div>
            <div
              v-if="form.file"
              class="sig-upload-status sig-upload-status--new"
            >
              <i class="el-icon-circle-check"></i>
              {{ form.file.name }}
            </div>
          </div>
          <el-form-item prop="file" class="sig-upload-action mb-0">
            <el-upload
              action="#"
              :auto-upload="false"
              :limit="1"
              ref="file"
              accept=".p12"
              :on-change="handleChangeFile"
              :show-file-list="false"
            >
              <el-button size="small" class="sig-upload-btn">
                <i class="el-icon-upload2"></i>
                Seleccionar archivo
              </el-button>
            </el-upload>
          </el-form-item>
        </div>

        <el-form-item prop="password" class="mt-3">
          <slot name="label">
            <label class="font-semi-bold m-0">Contraseña de firma</label>
          </slot>
          <el-input
            show-password
            type="password"
            name="password"
            :disabled="togglePassword"
            v-model="form.password"
          ></el-input>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import billingsService from "../services/billingsService";
import Validate from "@/assets/validate";

export default {
  name: "SignatureAddComponent",
  data() {
    return {
      form: {
        password: null,
        file: null
      },
      rules: {
        password: [Validate.rules.required()]
      }
    };
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    // El backend ya no expone la ruta ni la contraseña del .p12, solo si existe.
    getBusinessSriFile() {
      return this.getUser.user_business.has_sri_signature;
    },
    togglePassword() {
      return this.form.file ? false : true;
    }
  },
  methods: {
    async handleSaveClick() {
      // Sin archivo nuevo no hay nada que guardar: la contraseña solo
      // se puede cambiar junto con un .p12 nuevo.
      if (!this.form.file) {
        this.$notifications.warning({
          message: this.getBusinessSriFile
            ? "Selecciona un archivo .p12 nuevo para actualizar tu firma"
            : "Debes seleccionar un archivo .p12"
        });
        return;
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { file, password } = this.form;
          try {
            this.$store.dispatch("toggleRequestLoading");
            // Always create a fresh FormData to avoid duplicate entries
            const formData = new FormData();
            formData.append("password", password);
            formData.append("business_id", this.getUser.user_business.id);
            formData.append("file", file.raw);
            let response = await billingsService
              .uploadSign(formData, {
                header: { "Content-Type": "multipart/form-data" }
              })
              .finally(() => this.$store.dispatch("toggleRequestLoading"));
            const { success, message, data } = response.data;
            if (success) {
              this.$store.dispatch("userBusinessUpdated", data);
              this.$notifications.success({ message });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    handleChangeFile(file) {
      this.form.file = file;
    }
  },
  mounted() {
    this.$root.$on("negocio:save-signature", this.handleSaveClick);
  },
  beforeDestroy() {
    this.$root.$off("negocio:save-signature", this.handleSaveClick);
  }
};
</script>

<style lang="scss" scoped>
$primary: #2d2b55;
$accent: #3ecfb4;
$border: #e8ecf1;
$bg: #f7f8fc;

.sig-upload-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 12px;
  padding: 20px 24px;
  margin: 20px 0;
  transition: border-color 0.18s;

  &:hover {
    border-color: darken($border, 8%);
  }
}

.sig-upload-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: $bg;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sig-upload-icon-inner {
  font-size: 22px;
  color: $primary;
}

.sig-upload-info {
  flex: 1;
  min-width: 0;
}

.sig-upload-label {
  font-size: 14px;
  font-weight: 700;
  color: $primary;
  margin: 0 0 2px;
}

.sig-upload-hint {
  font-size: 12px;
  color: #909399;
  margin: 0 0 6px;
}

.sig-upload-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #1d9e75;
  background: #e4fff4;
  border-radius: 20px;
  padding: 2px 10px;

  &--new {
    color: $accent;
    background: #f0fdf9;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.sig-upload-action {
  flex-shrink: 0;
}

.sig-upload-btn {
  border: 1.5px solid $border;
  border-radius: 8px;
  color: $primary;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s;

  &:hover {
    border-color: $accent;
    color: $accent;
  }

  i {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .sig-upload-card {
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px;
  }
  .sig-upload-action {
    width: 100%;
  }
}
</style>
